"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdentifierData = exports.GetPersonDataBase = exports.InfoPreferencesData = exports.PreferencesData = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const MOLLanguage_1 = require("../../language/MOLLanguage");
const utils_1 = require("../../utils");
const IsDateOnly_1 = require("../../utils/validators/date/IsDateOnly");
const types_1 = require("./types");
const user_identifier_1 = require("./types/user-identifier");
class PreferencesData {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.PreferencesData = PreferencesData;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], PreferencesData.prototype, "displayName", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(types_1.AgeGroup),
    __metadata("design:type", String)
], PreferencesData.prototype, "ageGroup", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(MOLLanguage_1.MOLLanguage),
    __metadata("design:type", String)
], PreferencesData.prototype, "language", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], PreferencesData.prototype, "expecting", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(Object.values(types_1.UserInterest), { each: true }),
    __metadata("design:type", Array)
], PreferencesData.prototype, "interests", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(Object.values(types_1.ParentingMoment), { each: true }),
    __metadata("design:type", Array)
], PreferencesData.prototype, "parentingMoments", void 0);
__decorate([
    (0, IsDateOnly_1.IsDateOnly)({ isOptional: true }),
    __metadata("design:type", String)
], PreferencesData.prototype, "expectedDeliveryDate", void 0);
class InfoPreferencesData {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.InfoPreferencesData = InfoPreferencesData;
class GetPersonDataBase {
}
exports.GetPersonDataBase = GetPersonDataBase;
__decorate([
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.DateClassTransformer),
    __metadata("design:type", Date)
], GetPersonDataBase.prototype, "lastUpdated", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => types_1.AttributesLastUpdated),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", types_1.AttributesLastUpdated)
], GetPersonDataBase.prototype, "lastUpdatedByAttributeGroup", void 0);
class UserIdentifierData {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.UserIdentifierData = UserIdentifierData;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UserIdentifierData.prototype, "identifier", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(user_identifier_1.WogUserIdentifierType),
    __metadata("design:type", String)
], UserIdentifierData.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UserIdentifierData.prototype, "isPrimary", void 0);
//# sourceMappingURL=api-domain.js.map